<template>
  <b-field :label="label">
    <qd-taginput
      v-model="tiersSelected"
      :data="filteredTagsTiers"
      :loading="isFetchingTiers"
      @typing="getfilteredTiers"
      autocomplete
      icon="magnify"
      type="is-primary"
      field="nomCommercial"
      :disabled="disabled">
    <template slot-scope="props">
        {{ props.option.nomWithAdresse }}
    </template>
    <template slot="empty">
        <div v-if="!isFetchingTiers">
        {{$t('general.autocomplete.noRslt')}}
        </div>
    </template>
    </qd-taginput>
  </b-field>
</template>
<script>
import { getAll as getAllTiers } from '@/api/tiers';
import {
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import debounce from 'lodash/debounce';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: false,
    },
    societeActiveId: {
      required: true,
    },
    sousType: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filteredTagsTiers: [],
      isFetchingTiers: false,
    };
  },
  computed: {
    tiersSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    getfilteredTiers: debounce(async function getTiers(search) {
      this.filteredTagsTiers = [];
      if (!search) return;
      this.isFetchingTiers = true;
      try {
        const tiers = (await getAllTiers({
          query: {
            nomsCommercialOuNomsJuridique: [search],
            societeId: this.societeActiveId,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: this.sousType,
          },
        })).data.result.items;
        tiers.forEach((el) => {
          el.nomWithAdresse = el.nomCommercial;
          if (adressFullStringGetter(el.adressePostale, false) !== '') {
            el.nomWithAdresse += ' - ' + adressFullStringGetter(el.adressePostale, false);
          }
        });
        this.filteredTagsTiers = tiers.filter((el) => {
          return !this.tiersSelected.map(
            tiersSelected => tiersSelected.id,
          ).includes(el.id);
        });
        this.isFetchingTiers = false;
      } catch (e) {
        this.isFetchingTiers = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
  },
};
</script>
